import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import GradingOutlinedIcon from "@mui/icons-material/GradingOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import Diversity2OutlinedIcon from "@mui/icons-material/Diversity2Outlined";
import ChecklistRtlOutlinedIcon from "@mui/icons-material/ChecklistRtlOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import EditLocationAltOutlinedIcon from "@mui/icons-material/EditLocationAltOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import GroupsIcon from "@mui/icons-material/Groups";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";

export const BASE_NAVIGATION = [
  {
    kind: "header",
    titleKey: "userPanel",
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "home",
    titleKey: "home",
    icon: <AnnouncementOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "analytics",
    titleKey: "analytics",
    icon: <DashboardOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "profile",
    titleKey: "myProfile",
    icon: <AssignmentIndOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "myteam",
    titleKey: "myTeam",
    icon: <Groups2OutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    kind: "header",
    titleKey: "workPermits",
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "newptw",
    titleKey: "newPTW",
    icon: <CreateNewFolderOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "docs",
    titleKey: "allPTWs",
    icon: <GradingOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "mydocs",
    titleKey: "myPTWs",
    icon: <DescriptionOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "check-lists",
    titleKey: "checkLists",
    icon: <Diversity2OutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    kind: "header",
    titleKey: "observationsPanel",
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "newobservation",
    titleKey: "newObservation",
    icon: <DescriptionOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "observations",
    titleKey: "observations",
    icon: <FlagOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "myobservations",
    titleKey: "myObservations",
    icon: <GradingOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  {
    segment: "mytodos",
    titleKey: "myTodos",
    icon: <CreateNewFolderOutlinedIcon />,
    allowedUserTypes: ["ORG_USER", "ORG_ADMIN", "SUPERUSER"],
  },
  { kind: "header", titleKey: "adminPanel", allowedUserTypes: ["ORG_ADMIN"] },
  {
    segment: "orgsettings",
    titleKey: "orgSettings",
    icon: <FactoryOutlinedIcon />,
    defaultRoute: "/orgsettings",
    allowedUserTypes: ["ORG_ADMIN"],
    children: [
      {
        segment: "sites",
        titleKey: "sites",
        icon: <EditLocationAltOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
      {
        segment: "departments",
        titleKey: "departments",
        icon: <CorporateFareOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
      {
        segment: "usergroups",
        titleKey: "userGroups",
        icon: <GroupsIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
      {
        segment: "organization",
        titleKey: "organization",
        icon: <BusinessOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
    ],
  },
  {
    segment: "riskregister",
    titleKey: "riskRegister",
    icon: <SchemaOutlinedIcon />,
    defaultRoute: "/riskregister",
    allowedUserTypes: ["ORG_ADMIN"],
    children: [
      {
        segment: "workflows",
        titleKey: "workFlows",
        icon: <AddCardOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
      {
        segment: "hazards",
        titleKey: "hazards",
        icon: <ReportGmailerrorredOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
      {
        segment: "precautions",
        titleKey: "precautions",
        icon: <WarningAmberOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
    ],
  },
  {
    segment: "usermanagement",
    titleKey: "userManagement",
    icon: <Groups2OutlinedIcon />,
    defaultRoute: "/usermanagement",
    allowedUserTypes: ["ORG_ADMIN"],
    children: [
      {
        segment: "userlist",
        titleKey: "userList",
        icon: <FormatListBulletedOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
      {
        segment: "search",
        titleKey: "search",
        icon: <SearchOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
    ],
  },
  {
    segment: "communications",
    titleKey: "communication",
    icon: <CampaignOutlinedIcon />,
    defaultRoute: "/communications",
    allowedUserTypes: ["ORG_ADMIN"],
    children: [
      {
        segment: "announcement",
        titleKey: "announcement",
        icon: <CampaignOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
      {
        segment: "archive",
        titleKey: "archive",
        icon: <ArchiveOutlinedIcon />,
        allowedUserTypes: ["ORG_ADMIN"],
      },
    ],
  },
];
